import { NavLink } from "react-router-dom";
import Conditional from "../../core/Conditional";
import { ReactNode } from "react";

const HangerButton = ({
  label,
  to,
  icon,
  iconActive,
  children,
}: {
  label: ReactNode;
  to: string;
  icon: ReactNode;
  iconActive: ReactNode;
  children?: ReactNode;
}) => {
  return (
    <li className="rounded-lg">
      <NavLink to={to}>
        {({ isActive }) => (
          <>
            <Conditional when={isActive} show={iconActive}>
              {icon}
            </Conditional>
            {label}
            {children}
          </>
        )}
      </NavLink>
    </li>
  );
};
export default HangerButton;
